import 'react-phone-number-input/style.css';
import libParse from 'libphonenumber-js';
import ReactPhoneNumberInput from 'react-phone-number-input';
import { useField } from '@arc/frontend/util-common';
import { FormControl } from '../FormControl';
import { Input } from './Input';
const ALLOWED_COUNTRIES = ['US', 'EG', 'VN', 'IN'];
/**
 * Try to transform the given value into something that react-phone-number-input will display.
 *
 * react-phone-number-input does not display numbers that are not in E.164 format.
 * Only accepts phone numbers from allowed countries.
 */
function parsePhoneNumber(value) {
  if (typeof value !== 'string') return undefined;
  if (value === '') return undefined;
  for (const country of ALLOWED_COUNTRIES) {
    const parsed = libParse(value, country);
    if (parsed?.number) {
      return parsed.number;
    }
  }
  return value;
}
export function InputPhoneNumberWithControl(props) {
  const {
    name,
    label,
    defaultValue,
    outerStyle,
    ...other
  } = props;
  const {
    field: {
      value,
      onChange,
      ...field
    },
    fieldState: {
      invalid
    },
    errorMessage
  } = useField({
    name,
    defaultValue
  });
  const cleanedValue = parsePhoneNumber(value);
  return <FormControl outerStyle={outerStyle} label={label} error={invalid} helperText={errorMessage}>
			<ReactPhoneNumberInput {...field} onChange={inputValue => {
      /**
       * Regular inputs will return empty string when input is empty,
       * but react-phone-number-input will return undefined.
       * This coercion makes the empty behavior unified across our inputs.
       */
      if (inputValue === undefined) {
        onChange('');
      } else {
        onChange(inputValue);
      }
    }} value={cleanedValue} error={invalid} defaultCountry="US" countries={ALLOWED_COUNTRIES} inputComponent={Input} autoComplete="new-password" {...other} />
		</FormControl>;
}